import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "invoice" }
const _hoisted_2 = { class: "no-print" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ProIP.info ")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" support@proip.info ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Print")
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "mt-15" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Billed to:", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "billed-to"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_16 = { id: "not-printable1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("+ Add billing details")
const _hoisted_18 = { class: "ant-row-flex ant-row-flex-space-between" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Date: ")
const _hoisted_20 = { class: "ant-row-flex ant-row-flex-space-between" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Invoice #: ")
const _hoisted_22 = {
  key: 0,
  class: "ant-row-flex ant-row-flex-space-between"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" VAT #: ")
const _hoisted_24 = /*#__PURE__*/_createVNode("hr", { class: "mt-15" }, null, -1)
const _hoisted_25 = { class: "ant-table invoice-table" }
const _hoisted_26 = /*#__PURE__*/_createVNode("thead", { class: "ant-table-thead" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, [
      /*#__PURE__*/_createVNode("span", { class: "ant-table-header-column" }, [
        /*#__PURE__*/_createVNode("span", { class: "ant-table-column-title" }, " Description ")
      ])
    ]),
    /*#__PURE__*/_createVNode("th", { class: "table-right-text" }, [
      /*#__PURE__*/_createVNode("span", { class: "ant-table-header-column" }, [
        /*#__PURE__*/_createVNode("span", { class: "ant-table-column-title" }, " Qty ")
      ])
    ]),
    /*#__PURE__*/_createVNode("th", { class: "table-right-text" }, [
      /*#__PURE__*/_createVNode("span", { class: "ant-table-header-column" }, [
        /*#__PURE__*/_createVNode("span", { class: "ant-table-column-title" }, " Unit price ")
      ])
    ]),
    /*#__PURE__*/_createVNode("th", { class: "table-right-text" }, [
      /*#__PURE__*/_createVNode("div", { class: "ant-table-header-column" }, " Amount ")
    ])
  ])
], -1)
const _hoisted_27 = { class: "ant-table-tbody" }
const _hoisted_28 = { class: "ant-table-row ant-table-row-level-0" }
const _hoisted_29 = /*#__PURE__*/_createVNode("td", null, "Complete IP Database ProIP.info", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("td", { class: "text-right" }, "1", -1)
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = { class: "ant-row-flex ant-row-flex-space-between" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Subtotal: ")
const _hoisted_35 = { class: "ant-row-flex ant-row-flex-space-between" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" VAT: ")
const _hoisted_37 = { class: "ant-row-flex ant-row-flex-space-between" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Total: ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TheLogo = _resolveComponent("TheLogo")
  const _component_a_col = _resolveComponent("a-col")
  const _component_PrinterOutlined = _resolveComponent("PrinterOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, "Receipt # " + _toDisplayString(_ctx.id), 1),
    (_ctx.isLoadInvoiceCheck)
      ? (_openBlock(), _createBlock(_component_a_card, {
          key: 0,
          id: "section-to-print"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { lg: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TheLogo, {
                      color: "#202831",
                      width: 140
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { lg: 6 }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { lg: 8 }),
                _createVNode(_component_a_col, {
                  lg: 4,
                  id: "not-printable"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.print
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_PrinterOutlined)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_8,
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  lg: 12,
                  class: "billing-to"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    (_ctx.invoice.data)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.invoice.data.billedTo), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isBilledToViewBox)
                      ? (_openBlock(), _createBlock("div", _hoisted_13, [
                          _createVNode(_component_a_textarea, {
                            placeholder: "Billed to information. Example: Company name, billing or shipping address, VAT ID, ect.",
                            "auto-size": "",
                            value: _ctx.billedTo,
                            "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.billedTo = $event))
                          }, null, 8, ["value"]),
                          _createVNode(_component_a_button, { onClick: _ctx.openBilledTo }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _ctx.saveBilledTo,
                            id: "save-billed-button"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_16, [
                      (!_ctx.isBilledToViewBox)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            class: "not-printable",
                            onClick: _ctx.openBilledTo,
                            id: "add-billed-button"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { lg: 6 }),
                _createVNode(_component_a_col, {
                  lg: 6,
                  class: "billing-info"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode("span", null, _toDisplayString(_ctx.invoice.createdAt), 1)
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode("span", null, _toDisplayString(_ctx.invoice.id), 1)
                    ]),
                    (_ctx.invoiceVatNumber)
                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode("span", null, _toDisplayString(_ctx.invoiceVatNumber), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_24,
            _createVNode("table", _hoisted_25, [
              _hoisted_26,
              _createVNode("tbody", _hoisted_27, [
                _createVNode("tr", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _createVNode("td", _hoisted_31, _toDisplayString(_ctx.convertMoney(_ctx.invoice.total)), 1),
                  _createVNode("td", _hoisted_32, _toDisplayString(_ctx.convertMoney(_ctx.invoice.total)), 1)
                ])
              ])
            ]),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { lg: 18 }),
                _createVNode(_component_a_col, {
                  lg: 6,
                  class: "billing-total"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode("span", null, _toDisplayString(_ctx.convertMoney(_ctx.invoice.subtotal)), 1)
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("span", null, _toDisplayString(_ctx.invoice.tax) + "%", 1)
                    ]),
                    _createVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode("span", null, _toDisplayString(_ctx.convertMoney(_ctx.invoice.total)), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}